import { useTranslation } from 'react-i18next'

import { ActionSelect } from '../../../Action'
import { QA_NAME_TABLE_CONTROL_BUTTONS_MENU } from '../TableControlButtons.constants'
import { getTableControlButtonsActionsSelectOptions } from '../TableControlButtons.utils'

function TableControlButtonsActionsSelect(props) {
  const { t } = useTranslation()

  const actions = getTableControlButtonsActionsSelectOptions(props, t)

  function handleClickAction({ value: actionValue }) {
    actions.find(a => a.value === actionValue)?.onClick?.()
  }

  return actions.length > 0 ? (
    <ActionSelect
      actions={actions}
      controlProps={{
        buttonProps: { qaName: QA_NAME_TABLE_CONTROL_BUTTONS_MENU },
      }}
      onClickAction={handleClickAction}
    />
  ) : null
}

export default TableControlButtonsActionsSelect
